"use client";

import * as React from "react";
import { Mail, Phone, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
const steps = [{
  id: "step-1",
  numeral: "01",
  title: "Εντοπισμός Email Επιβεβαίωσης",
  content: "Αναζητήστε στα εισερχόμενά σας το email επιβεβαίωσης που λάβατε κατά την ολοκλήρωση της κράτησής σας. Ελέγξτε και τον φάκελο ανεπιθύμητης αλληλογραφίας (spam) εάν δεν το βρίσκετε άμεσα."
}, {
  id: "step-2",
  numeral: "02",
  title: "Έλεγχος Χρονικών Περιθωρίων",
  content: "Διαβάστε προσεκτικά τους όρους ακύρωσης που αναγράφονται στο email. Βεβαιωθείτε ότι το αίτημά σας υποβάλλεται εντός των επιτρεπτών χρονικών ορίων που έχει θέσει το κατάλυμα για δωρεάν ακύρωση ή τροποποίηση."
}, {
  id: "step-3",
  numeral: "03",
  title: "Ολοκλήρωση Διαδικασίας",
  content: "Κάντε κλικ στον ειδικό σύνδεσμο 'Διαχείριση Κράτησης' που περιλαμβάνεται στο email και ακολουθήστε τα βήματα στην οθόνη για να ολοκληρώσετε την ακύρωση ή την τροποποίηση της κράτησής σας με ασφάλεια."
}];
export default function CancellationProcess() {
  return <section id="4-διαδικασία-ακύρωσης" className="bg-background py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div className="lg:col-span-8 flex flex-col gap-10">
            <div className="space-y-6">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground font-default tracking-tight">
                Διαδικασία Ακύρωσης
              </h2>
              <p className="text-lg md:text-xl text-muted-foreground font-default leading-relaxed max-w-3xl">
                Εάν επιθυμείτε να ακυρώσετε ή να τροποποιήσετε την κράτησή σας,
                παρακαλούμε ακολουθήστε τις οδηγίες που αναγράφονται στο email
                επιβεβαίωσης της κράτησής σας, τηρώντας πάντα τα χρονικά
                περιθώρια που έχει θέσει το κατάλυμα. Για οποιαδήποτε περαιτέρω
                διευκρίνιση, η ομάδα υποστήριξης παραμένει στη διάθεσή σας.
              </p>
            </div>

            <Accordion type="single" collapsible className="w-full" defaultValue="step-1">
              {steps.map((step, i) => <AccordionItem key={step.id} value={step.id} data-index={i} className="border-border py-4">
                  <AccordionTrigger className="hover:no-underline group py-2">
                    <div className="flex items-center gap-6 text-left">
                      <span className="text-5xl md:text-6xl font-bold text-primary font-['Montserrat'] group-hover:scale-105 transition-transform duration-300">
                        {step.numeral}
                      </span>
                      <span className="text-xl md:text-2xl font-semibold text-foreground font-default">
                        {step.title}
                      </span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="pl-[5.5rem] md:pl-[6.5rem] pt-2 text-base md:text-lg text-muted-foreground font-default leading-relaxed">
                    {step.content}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>

          {}
          <div className="lg:col-span-4 lg:sticky lg:top-24">
            
          </div>
        </div>
      </div>
    </section>;
}